import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import BackOfficeRouter from './router'
import themes from './theme/index'
import { useGlobalStore } from './store'

const queryClient = new QueryClient({
  defaultOption: { queries: { retry: 3, retryDelay: 1500 } }
})

const App = () => {
  const { theme } = useGlobalStore()
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={themes[theme]}>
          <CssBaseline />
          <BackOfficeRouter />
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      </QueryClientProvider>
    </BrowserRouter>
  )
}

export default App
